module.exports = __webpack_public_path__ + "static/media/invites.1857fc3d.svg";